module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAMAAABAUVr7AAAAQlBMVEVHcEz////////////////////////////////////////////////////////////////////////////////////1bZCPAAAAFXRSTlMA6cKuBKAM+vI8eS9PbyaQh9UV4WCrJ47tAAAA30lEQVQ4y4WTWQ6EIBAF2UFAAZX7X3VE49JNO74PE0OxhFcwdid4WYr0gb1EDaIesWKgiVTv2KwIQlYQ3TOponhMDBYjdkKIqF00JCbbI24GyFqJxP+H7Q+sKSR9IxkgmUJGgEQKgW0a3hMLqiB/7bMts2CimE4WdL+O8CoCxhFSTdAXq+duDYdLxL6MuOmCbVlJn5Q5P9vbwLtU2eZxl0woVmynUoLyILS9BT/0i+TNjtcPf/P2RgqbiJK5eejsHzjU6Wx2mZmkEBuZ0lcVnELayP7KeSuLXOWYHfle1Q/dgzR009dqAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/icon_fans.png
// module id = xyHa
// module chunks = 1